import './SearchInput.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var searchInput = _7a468({defaultClassName:'_1mumub80-3-8-0',variantClassNames:{hasStepper:{true:'_1mumub81-3-8-0'}},defaultVariants:{},compoundVariants:[]});